import React from 'react'
import { Select, type SelectProps } from '@mui/material'

import './AccessibleGrid.scss'

interface BaseSelectProps<Value = unknown> extends Omit<SelectProps<Value>, 'variant'> {
  variant?: 'outlined'
  ariaLabel?: string
}

const CellSelectInput = <Value = unknown,>({
  variant = 'outlined',
  disabled,
  value,
  ariaLabel: ariaLabelOverride,
  ...props
}: BaseSelectProps<Value>): React.ReactElement => {
  const ariaLabel =
    ariaLabelOverride ??
    (Array.isArray(value)
      ? value.length > 0
        ? value.join(', ')
        : 'blank'
      : value && value !== ''
        ? String(value)
        : 'blank')
  return (
    <Select
      variant={variant}
      disabled={disabled}
      value={value}
      className={`cell-select-input${disabled ? ' cell-select-input--disabled' : ''}`}
      {...props}
      inputProps={{
        ...props.inputProps,
        'aria-label': ariaLabel,
      }}
      MenuProps={{
        disableScrollLock: true,
        ...props.MenuProps,
      }}
    />
  )
}

export default CellSelectInput
